"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var react_redux_2 = require("@nimles/react-redux");

var ImageGrid_1 = require("./ImageGrid");

exports.ImageSelector = function (_a) {
  var selected = _a.selected,
      onSelect = _a.onSelect;
  var dispatch = react_redux_1.useDispatch();
  var images = react_redux_1.useSelector(function (_a) {
    var files = _a.files;
    return files.values;
  });
  react_1.useEffect(function () {
    dispatch(react_redux_2.loadFiles());
  }, []);
  return react_1.default.createElement(ImageGrid_1.ImageGrid, {
    images: images,
    onSelect: onSelect,
    selected: selected
  });
};